import { Hero } from "./home/Hero";
import { Manifesto } from "./home/Manifesto";
import { Pillars } from "./home/Pillars";
import { LandscapeBand } from "./home/LandscapeBand";
import { ProductsBento } from "./home/ProductsBento";
import { LatestInsights } from "./home/LatestInsights";
import { Process } from "../components/Process";
import { ContactCTA } from "../components/ContactCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Manifesto />
      <Pillars />
      <LandscapeBand />
      <ProductsBento />
      <Process />
      <LatestInsights />
      <ContactCTA />
    </main>
  );
}
